var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.69064 4.94064C6.8615 4.76979 7.1385 4.76979 7.30936 4.94064L10.8094 8.44064C10.9802 8.6115 10.9802 8.8885 10.8094 9.05936C10.6385 9.23021 10.3615 9.23021 10.1906 9.05936L7 5.86872L3.80936 9.05936C3.6385 9.23021 3.3615 9.23021 3.19064 9.05936C3.01979 8.8885 3.01979 8.6115 3.19064 8.44064L6.69064 4.94064Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/ArrowUp.0985a1f0864439ac82ea66c2430a3d8e.svg";
export { ForwardRef as ReactComponent };